import { IMPORTTASKTEMPLATE_SUCCESS, IMPORTTASKTEMPLATE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const ImportTaskTemplateReducer = (state = initialState, action) => {
    switch (action.type) {
        case IMPORTTASKTEMPLATE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case IMPORTTASKTEMPLATE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default ImportTaskTemplateReducer;
